import { render, staticRenderFns } from "./vip-quintessence.vue?vue&type=template&id=190b90fd&scoped=true&"
import script from "./vip-quintessence.vue?vue&type=script&lang=js&"
export * from "./vip-quintessence.vue?vue&type=script&lang=js&"
import style0 from "./vip-quintessence.vue?vue&type=style&index=0&id=190b90fd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190b90fd",
  null
  
)

export default component.exports